import { environment, ENVIRONMENTS } from './helpers/utils';

export const powerBiReportsUrl = environment === ENVIRONMENTS.PRODUCTION
  ? 'https://app.powerbi.com/links/wUARR-Kuyk?ctid=324f02a1-b901-46ec-867e-a62e49604dbb&pbi_source=linkShare&bookmarkGuid=5da5f0fa-f878-4c0e-a2b3-94ba870ddfde'
  : 'https://app.powerbi.com/groups/me/reports/ecbdd567-e659-4d7a-9116-e5853ac813ca?ctid=324f02a1-b901-46ec-867e-a62e49604dbb&pbi_source=linkShare'